export default function initBlogFilter () {
    const searchInput = document.getElementById("searchInput");
    const clearBtn = document.getElementById("clearBtn");
    const categoryDropdown = document.getElementById("categoryDropdown");
    const sortDropdown = document.getElementById("sortDropdown");
    const cardsContainer = document.querySelector(".blog__cards .row");

    if (!cardsContainer) {
        return;
    }

    const cards = Array.from(cardsContainer.querySelectorAll("article"));

    function getUrlParams () {
        const params = new URLSearchParams(window.location.search);
        return {
            category: params.get("category") || "all",
            query: params.get("query") || "",
            sort: params.get("sort") || "date"
        };
    }

    const { category, query, sort } = getUrlParams();

    let currentSearch = query.toLowerCase();
    let currentCategory = category;
    let currentSort = sort;

    function highlightMatch (text, term) {
        const regex = new RegExp(`(${term})`, 'gi');
        return text.replace(regex, '<mark>$1</mark>');
    }

    function clearHighlights () {
        cards.forEach(card => {
            const titleEl = card.querySelector(".card-title");
            const originalText = titleEl.getAttribute("data-original-title");
            if (originalText) {
                titleEl.innerHTML = originalText;
            }
        });
    }

    function getViewCount (card) {
        const viewEl = card.querySelector(".view");
        if (!viewEl) return 0;
        const value = parseInt(viewEl.textContent.replace(/\D/g, ''), 10);
        return isNaN(value) ? 0 : value;
    }

    function filterAndSortCards () {
        let filteredCards = cards;

        clearHighlights();

        if (currentSearch) {
            filteredCards = filteredCards.filter(card => {
                const titleEl = card.querySelector(".card-title");
                const titleText = titleEl.textContent.toLowerCase();
                return titleText.includes(currentSearch);
            });

            filteredCards.forEach(card => {
                const titleEl = card.querySelector(".card-title");
                const original = titleEl.textContent;

                if (!titleEl.hasAttribute("data-original-title")) {
                    titleEl.setAttribute("data-original-title", original);
                }

                titleEl.innerHTML = highlightMatch(original, currentSearch);
            });
        }

        if (currentCategory !== "all") {
            filteredCards = filteredCards.filter(card =>
                card.dataset.category === currentCategory
            );
        }

        filteredCards.sort((a, b) => {
            if (currentSort === "date") {
                return new Date(b.querySelector("time").getAttribute("datetime")) -
                    new Date(a.querySelector("time").getAttribute("datetime"));
            } else if (currentSort === "views") {
                return getViewCount(b) - getViewCount(a);
            } else if (currentSort === "az") {
                return a.querySelector(".card-title").textContent.localeCompare(
                    b.querySelector(".card-title").textContent
                );
            } else if (currentSort === "za") {
                return b.querySelector(".card-title").textContent.localeCompare(
                    a.querySelector(".card-title").textContent
                );
            }
        });

        cards.forEach(card => card.style.display = "none");
        filteredCards.forEach(card => cardsContainer.appendChild(card));
        filteredCards.forEach(card => card.style.display = "block");
    }

    if (searchInput) searchInput.value = query;

    const categoryItem = document.querySelector(`#categoryDropdown + .dropdown-menu a[data-value="${currentCategory}"]`);
    if (categoryItem) {
        categoryDropdown.textContent = categoryItem.textContent;
    }

    const sortItem = document.querySelector(`#sortDropdown + .dropdown-menu a[data-value="${currentSort}"]`);
    if (sortItem) {
        sortDropdown.textContent = sortItem.textContent;
    }

    searchInput.addEventListener("input", () => {
        currentSearch = searchInput.value.trim().toLowerCase();
        filterAndSortCards();
    });

    clearBtn.addEventListener("click", () => {
        searchInput.value = "";
        currentSearch = "";
        filterAndSortCards();
    });

    document.querySelectorAll("#categoryDropdown + .dropdown-menu a").forEach(item => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            currentCategory = item.dataset.value;
            categoryDropdown.textContent = item.textContent;
            filterAndSortCards();

            const params = new URLSearchParams(window.location.search);
            params.set("category", currentCategory);
            history.replaceState(null, "", "?" + params.toString());
        });
    });

    document.querySelectorAll("#sortDropdown + .dropdown-menu a").forEach(item => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            currentSort = item.dataset.value;
            sortDropdown.textContent = item.textContent;
            filterAndSortCards();

            const params = new URLSearchParams(window.location.search);
            params.set("sort", currentSort);
            history.replaceState(null, "", "?" + params.toString());
        });
    });

    filterAndSortCards();
}